// Coordinate cart writes within this document; server-side rules remain authoritative.
(function () {
  let owner = null;
  let uncertain = false;
  let revision = 0;
  const controls = '[data-sidecart-qty], [data-cart-mutation], [data-cart-checkout], form[action*="/cart/add"] [type="submit"]';
  const blocked = () => owner !== null || uncertain;
  const refresh = () => {
    document.querySelectorAll(controls).forEach(control => {
      const readState = control.closest('[data-sidecart]')?.dataset.cartReadState;
      if (blocked() || (readState && readState !== 'ready')) {
        if (!control.hasAttribute('data-cart-lock')) control.dataset.cartLock = String(Boolean(control.disabled));
        if ('disabled' in control) control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
      } else if (control.hasAttribute('data-cart-lock')) {
        if ('disabled' in control) control.disabled = control.dataset.cartLock === 'true';
        delete control.dataset.cartLock;
        control.removeAttribute('aria-disabled');
      }
    });
  };
  const notify = () => {
    refresh();
    document.dispatchEvent(new CustomEvent('lev:cart-state', { detail: { pending: owner !== null, uncertain, revision } }));
  };
  const isCart = cart => Boolean(cart && Array.isArray(cart.items) && Number.isSafeInteger(cart.item_count) && cart.item_count >= 0 && Number.isSafeInteger(cart.total_price) && cart.total_price >= 0 && cart.items.every(item => item && typeof item.key === 'string' && item.key.length > 0 && Number.isSafeInteger(item.quantity) && item.quantity > 0 && Number.isSafeInteger(item.final_line_price) && item.final_line_price >= 0 && typeof item.product_title === 'string') && new Set(cart.items.map(item => item.key)).size === cart.items.length && cart.items.reduce((sum, item) => sum + item.quantity, 0) === cart.item_count);
  window.LevCartSession = Object.freeze({
    blocked,
    refresh,
    isCart,
    snapshot: () => ({ revision, pending: owner !== null, uncertain }),
    begin() {
      if (blocked()) return null;
      owner = Symbol('cart-write');
      revision++;
      notify();
      return owner;
    },
    finish(token, confirmed) {
      if (!token || token !== owner) return false;
      owner = null;
      uncertain = confirmed !== true;
      revision++;
      notify();
      return true;
    },
  });
  document.addEventListener('click', event => {
    const checkout = event.target.closest('[data-cart-checkout]');
    if (checkout && (blocked() || checkout.getAttribute('aria-disabled') === 'true')) event.preventDefault();
  }, true);
  document.addEventListener('submit', event => {
    if (blocked() && event.target.matches('#levCartForm')) event.preventDefault();
  }, true);
})();

// Lead and WhatsApp conversions follow Shopify's customer events model: the theme only publishes custom events, and the
// custom pixels in Settings > Customer events (versioned in pixels/) forward them to Meta and GA4 under the consent set there.
// Page views and the purchase funnel come from the Facebook & Instagram and Google & YouTube apps.
(function () {
  const LEAD_FORMS = { dealer: 'sejaumrevendedor_form', popup: 'home_popup' };
  const WHATSAPP_HOSTS = ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'];
  const reportedInMemory = new Set();

  // A tracking failure must never turn a confirmed action into an error for the visitor.
  const publish = (name, data) => {
    try {
      if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
      window.Shopify.analytics.publish(name, data);
      return true;
    } catch {
      console.warn(`[lev-tracking] ${name} not published`);
      return false;
    }
  };
  const alreadyReported = eventId => {
    if (reportedInMemory.has(eventId)) return true;
    try { return sessionStorage.getItem('lev-lead-reported-v1:' + eventId) === 'sent'; } catch { return false; }
  };
  const markReported = eventId => {
    reportedInMemory.add(eventId);
    try { sessionStorage.setItem('lev-lead-reported-v1:' + eventId, 'sent'); } catch { /* the in-memory mark still prevents repeats on this page */ }
  };

  // Call only after the receiver confirmed the lead: one event per receipt, never personal data.
  const lead = (kind, receiptId, details = {}) => {
    const formName = LEAD_FORMS[kind];
    const receipt = typeof receiptId === 'number' && Number.isSafeInteger(receiptId) ? String(receiptId) : typeof receiptId === 'string' ? receiptId.trim() : '';
    if (!formName || !/^[\w.:-]{1,128}$/.test(receipt)) return;
    const eventId = kind + ':' + receipt;
    if (alreadyReported(eventId)) return;
    const campaignId = typeof details.campaign_id === 'string' ? details.campaign_id.slice(0, 100) : '';
    if (publish('lev:lead', { lead_type: kind, form_name: formName, event_id: eventId, ...(campaignId ? { campaign_id: campaignId } : {}) })) markReported(eventId);
  };

  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    if (!WHATSAPP_HOSTS.includes(url.hostname)) return;
    const number = (url.hostname === 'wa.me' ? url.pathname : url.searchParams.get('phone') || '').replace(/\D/g, '').slice(0, 15);
    publish('lev:whatsapp_click', { whatsapp_number: number });
  }, true);

  // Lead forms post where the visit came from, as next-golev did. Captured on landing because the form sits far below the
  // landing URL; kept per session so an old campaign does not take credit for a later organic visit.
  const ATTRIBUTION_KEY = 'lev-attribution-v1';
  const ATTRIBUTION_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
  const clean = value => (typeof value === 'string' && value.trim() ? value.trim().slice(0, 255) : null);
  const captureAttribution = () => {
    try {
      const params = new URLSearchParams(location.search);
      const fromUrl = Object.fromEntries(ATTRIBUTION_PARAMS.map(key => [key, clean(params.get(key))]));
      if (sessionStorage.getItem(ATTRIBUTION_KEY) && !Object.values(fromUrl).some(Boolean)) return;
      let referrer = null;
      try { referrer = document.referrer && new URL(document.referrer).hostname !== location.hostname ? clean(document.referrer) : null; } catch { /* malformed referrer is not an origin */ }
      sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify({ ...fromUrl, landing_page: clean(location.origin + location.pathname), referrer }));
    } catch { /* storage unavailable: forms are sent without origin data */ }
  };
  const attribution = () => {
    try {
      const stored = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || '{}');
      return Object.fromEntries([...ATTRIBUTION_PARAMS, 'landing_page', 'referrer'].map(key => [key, clean(stored[key])]).filter(([, value]) => value));
    } catch {
      return {};
    }
  };
  captureAttribution();

  window.LevTracking = Object.freeze({ lead, attribution });
})();

document.addEventListener('DOMContentLoaded', function () {
  const translations = document.documentElement.dataset;
  const messages = {
    cartAdd: translations.cartAdd || 'Adicionar ao carrinho',
    cartUnavailable: translations.cartUnavailable || 'Combinação indisponível',
    cartError: translations.cartError || 'Não foi possível adicionar o item. Confira a seleção e tente novamente.',
    cartView: translations.cartView || 'Conferir carrinho',
    cartAdded: translations.cartAdded || 'Item adicionado ao carrinho.',
    cartAddedReview: translations.cartAddedReview || 'O item foi adicionado. Confira o carrinho antes de continuar.',
    cartUncertain: translations.cartUncertain || 'Não foi possível confirmar o resultado. Confira o carrinho antes de tentar novamente.',
    cartPix: translations.cartPix || '[price] à vista no PIX',
    cartInstallments: translations.cartInstallments || 'ou 12x de [price] sem juros',
    cartLoading: translations.cartLoading || 'Carregando carrinho…',
    cartUpdating: translations.cartUpdating || 'Atualizando carrinho…',
    cartUpdated: translations.cartUpdated || 'Carrinho atualizado. Confira as quantidades e o total.',
    cartReadError: translations.cartReadError || 'Não foi possível carregar o carrinho. Abra novamente ou confira a página do carrinho.',
  };
  const pendingAdds = new WeakSet();
  const galleryVariants = new WeakMap();
  const cartSession = window.LevCartSession;
  function showProductImage(gallery, image) {
    const main = gallery?.querySelector('[data-pdp-main]');
    if (!main || !image?.src) return;
    main.src = image.src;
    main.alt = image.alt || '';
    gallery.querySelectorAll('[data-pdp-thumb]').forEach(thumb => {
      const active = thumb.dataset.full === image.src;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
  }
  function showCartStatus(form, message, cartLink = false) {
    let status = form.querySelector('[data-cart-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.cartStatus = '';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
    }
    status.textContent = message;
    if (cartLink) {
      const link = document.createElement('a');
      link.href = (window.Shopify?.routes?.root || '/') + 'cart';
      link.textContent = messages.cartView;
      status.append(' ', link);
    }
  }
  function syncProductVariant(form) {
    const source = form.querySelector('[data-product-variants]');
    if (!source) return true;
    const idInput = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[type="submit"]');
    let matched;
    try {
      const variants = JSON.parse(source.textContent);
      const selected = Array.from(form.querySelectorAll('.lev-selector-group')).map(group => group.querySelector('.is-selected')?.dataset.optionValue);
      matched = selected.length ? variants.find(variant => variant.options.length === selected.length && variant.options.every((value, index) => value === selected[index])) : variants.find(variant => String(variant.id) === idInput?.value);
    } catch (error) {
      showCartStatus(form, messages.cartError);
    }
    form.querySelectorAll('[data-option-value]').forEach(option => option.setAttribute('aria-pressed', String(option.classList.contains('is-selected'))));
    const gallery = form.closest('.lev-pdp-body')?.querySelector('[data-product-gallery]');
    const main = gallery?.querySelector('[data-pdp-main]');
    if (main && (!galleryVariants.has(form) || galleryVariants.get(form) !== matched?.id)) {
      if (!main.dataset.defaultSrc) {
        main.dataset.defaultSrc = main.getAttribute('src');
        main.dataset.defaultAlt = main.alt;
      }
      showProductImage(gallery, matched?.image || { src: main.dataset.defaultSrc, alt: main.dataset.defaultAlt });
      galleryVariants.set(form, matched?.id);
    }
    const available = Boolean(matched?.available && idInput);
    if (idInput) { idInput.value = matched ? String(matched.id) : ''; idInput.disabled = !available; }
    if (button) {
      button.disabled = cartSession.blocked() || !available || pendingAdds.has(form) || form.dataset.cartUncertain === 'true';
      button.textContent = available ? messages.cartAdd : messages.cartUnavailable;
    }
    const scope = form.closest('.lev-pdp-right') || form;
    const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: form.dataset.currency || 'BRL' }).format(cents / 100);
    const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
    scope.querySelectorAll('.lev-price-main').forEach(element => { element.textContent = matched ? format(matched.price) : '—'; });
    scope.querySelectorAll('.lev-total-price').forEach(element => { element.textContent = matched ? format(matched.price * quantity) : '—'; });
    form.querySelectorAll('[data-pdp-pix]').forEach(element => { element.textContent = matched ? messages.cartPix.replace('[price]', format(matched.price * quantity)) : '—'; });
    form.querySelectorAll('.lev-installments:not([data-pdp-offer-installments])').forEach(element => { element.textContent = matched ? messages.cartInstallments.replace('[price]', format(Math.round(matched.price * quantity / 12))) : '—'; });
    // Campaign prices by payment method (snippets/lev-payment-offer.liquid); the elements exist only while the theme setting is on.
    const offer = window.LevPaymentOffer;
    if (offer) {
      const offerPrices = matched ? offer.prices(matched.price * quantity) : null;
      form.querySelectorAll('[data-pdp-offer-pix]').forEach(element => { element.textContent = offerPrices ? offer.text('pdp_pix', offerPrices) : '—'; });
      form.querySelectorAll('[data-pdp-offer-installments]').forEach(element => { element.textContent = offerPrices ? offer.text('pdp_installments', offerPrices) : '—'; });
    }
    return available;
  }
  document.querySelectorAll('form.lev-product-form').forEach(syncProductVariant);
  document.addEventListener('input', event => {
    if (event.target.matches('form.lev-product-form [name="quantity"]')) syncProductVariant(event.target.closest('form'));
  });

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const assetUrl = (name) => {
    if (!name) return name;
    if (/^(https?:)?\/\//.test(name)) return name;
    const found = document.querySelector(`img[src*="${name}"]`);
    if (found) return found.src;
    const css = document.querySelector('link[href*="golev-vtex-theme"]');
    if (!css) return name;
    return css.href.replace(/golev-vtex-theme[^/?]+(\?.*)?$/, name);
  };

  const mobileToggles = document.querySelectorAll('[data-mobile-toggle]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const resetMobileAccordions = () => {
    document.querySelectorAll('[data-mob-accordion]').forEach((accordion) => {
      accordion.classList.remove('is-open');
      accordion.querySelector('.lev-mob-trigger')?.setAttribute('aria-expanded', 'false');
    });
  };
  if (mobileDrawer) {
    mobileDrawer.id ||= 'lev-mobile-navigation';
    mobileToggles.forEach((button) => {
      button.setAttribute('aria-controls', mobileDrawer.id);
      button.setAttribute('aria-expanded', 'false');
    });
  }
  const openDrawer = () => {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add('is-open');
    mobileDrawer.setAttribute('aria-hidden', 'false');
    mobileToggles.forEach((b) => { b.textContent = '✕'; b.setAttribute('aria-expanded', 'true'); });
  };
  const closeDrawer = (restoreFocus = false) => {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('is-open');
    mobileDrawer.classList.remove('is-wide');
    mobileDrawer.setAttribute('aria-hidden', 'true');
    mobileToggles.forEach((b) => { b.textContent = '☰'; b.setAttribute('aria-expanded', 'false'); });
    resetMobileAccordions();
    if (restoreFocus) Array.from(mobileToggles).find((button) => !mobileDrawer.contains(button))?.focus();
  };
  mobileToggles.forEach((btn) => {
    btn.addEventListener('click', function () {
      mobileDrawer && mobileDrawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });
  });
  document.addEventListener('click', (e) => {
    if (!mobileDrawer || !mobileDrawer.classList.contains('is-open')) return;
    if (!mobileDrawer.contains(e.target) && !Array.from(mobileToggles).some((b) => b.contains(e.target))) closeDrawer();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileDrawer?.classList.contains('is-open')) {
      event.preventDefault();
      closeDrawer(true);
    }
  });

  // Só Bikes e Collabs alargam o painel; em Atendimento a referência mantém
  // os 234px da navbar.
  const widensDrawer = (acc) => !!acc.querySelector('[data-mob-bike-track], [data-mob-collab-track]');

  // Setas do carrossel de Collabs: aparecem conforme sobra conteúdo pra cada
  // lado, como o canScrollLeft/canScrollRight da referência.
  const syncCollabNav = (acc) => {
    const track = acc.querySelector('[data-mob-collab-track]');
    if (!track || !track.clientWidth) return;
    const prev = acc.querySelector('[data-mob-collab-prev]');
    const next = acc.querySelector('[data-mob-collab-next]');
    const max = track.scrollWidth - track.clientWidth;
    if (prev) prev.classList.toggle('is-available', track.scrollLeft > 1);
    if (next) next.classList.toggle('is-available', track.scrollLeft < max - 1);
  };
  // Carrossel de bikes: a bike mais perto do centro fica opaca, sua caixa de
  // specs acende e o marcador verde desliza até ela (Glow da referência).
  const GLOW_W = 36;
  const syncBikeCarousel = (scroller, initial) => {
    const slides = Array.from(scroller.querySelectorAll('.lev-mob-bike-slide'));
    if (!slides.length || !scroller.clientWidth) return;
    const specs = Array.from(scroller.querySelectorAll('.lev-mob-bike-specs'));
    const rule = scroller.querySelector('.lev-mob-bike-rule');
    const glow = scroller.querySelector('[data-mob-bike-glow]');
    const scRect = scroller.getBoundingClientRect();
    const centerX = scRect.left + scroller.clientWidth / 2;

    let idx = 0;
    let best = Infinity;
    let bikeCenterX = 0;
    slides.forEach((el, i) => {
      const r = el.getBoundingClientRect();
      const c = r.left + r.width / 2;
      const d = Math.abs(c - centerX);
      if (d < best) { best = d; idx = i; bikeCenterX = c; }
    });

    slides.forEach((el, i) => el.classList.toggle('is-centered', i === idx));
    specs.forEach((el, i) => el.classList.toggle('is-active', i === idx));

    if (glow && rule) {
      // A referência centra o marcador na abertura (glowWidth/2) e usa
      // glowWidth/3 depois de rolar — mantido igual para não divergir dela.
      const shift = initial ? GLOW_W / 2 : GLOW_W / 3;
      const x = bikeCenterX - rule.getBoundingClientRect().left - shift;
      glow.style.setProperty('transform', 'translateX(' + x + 'px)', 'important');
    }
  };

  document.querySelectorAll('[data-mob-bike-track]').forEach((scroller) => {
    scroller.addEventListener('scroll', () => syncBikeCarousel(scroller, false), { passive: true });
  });

  const touchedCarousels = new WeakSet();
  document.querySelectorAll('[data-mob-collab-track]').forEach((track) => {
    const acc = track.closest('[data-mob-accordion]');
    if (!acc) return;
    const step = () => track.clientWidth || 200;
    track.addEventListener('scroll', () => syncCollabNav(acc), { passive: true });
    const prev = acc.querySelector('[data-mob-collab-prev]');
    const next = acc.querySelector('[data-mob-collab-next]');
    const markInteraction = () => touchedCarousels.add(track);
    ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(type => track.addEventListener(type, markInteraction, { passive: true }));
    const move = (direction) => {
      markInteraction();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * step(), behavior: reducedMotion ? 'auto' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', () => move(-1));
    if (next) next.addEventListener('click', () => move(1));
  });

  document.querySelectorAll('[data-mob-accordion]').forEach((acc, index) => {
    const trigger = acc.querySelector('.lev-mob-trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      const panel = acc.querySelector('.lev-mob-sub');
      if (panel) {
        panel.id ||= `lev-mobile-submenu-${index}`;
        trigger.setAttribute('aria-controls', panel.id);
      }
      trigger.addEventListener('click', () => {
        const wasOpen = acc.classList.contains('is-open');
        resetMobileAccordions();
        if (mobileDrawer) mobileDrawer.classList.remove('is-wide');
        if (!wasOpen) {
          acc.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          if (mobileDrawer && widensDrawer(acc)) mobileDrawer.classList.add('is-wide');
          // O carrossel de bikes abre rolado no fim (o navegador ancora o
          // scroll ao expandir a sanfona), escondendo a primeira bike.
          const track = acc.querySelector('[data-mob-bike-track], [data-mob-collab-track]');
          if (track) {
            const isBikes = track.matches('[data-mob-bike-track]');
            // O submenu acabou de sair do display:none: a primeira medida pode
            // vir zerada, então remede depois do layout. Sem depender só de
            // requestAnimationFrame, que não roda com a aba em segundo plano.
            const sync = () => {
              syncCollabNav(acc);
              if (isBikes) syncBikeCarousel(track, true);
            };
            touchedCarousels.delete(track);
            const resetAndSync = () => { if (!touchedCarousels.has(track)) track.scrollLeft = 0; sync(); };
            requestAnimationFrame(resetAndSync);
            window.setTimeout(resetAndSync, 80);
            window.setTimeout(sync, 320);
          }
        }
      });
    }
  });

  document.querySelectorAll('[data-collab-track]').forEach((track) => {
    const panel = track.closest('[data-mega-panel]');
    const previous = panel?.querySelector('[data-collab-prev]');
    const next = panel?.querySelector('[data-collab-next]');
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sync = () => {
      if (previous) previous.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    };
    const move = (direction) => track.scrollBy({ left: direction * 400, behavior: reducedMotion() ? 'auto' : 'smooth' });
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', sync, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const cards = Array.from(track.querySelectorAll('a'));
      const current = cards.indexOf(document.activeElement);
      const index = Math.max(0, Math.min(cards.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1)));
      cards[index]?.focus({ preventScroll: true });
      cards[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' });
    });
    let animation = 0;
    let direction = 0;
    const stop = () => { cancelAnimationFrame(animation); animation = 0; direction = 0; };
    const scrollFrame = () => {
      const before = track.scrollLeft;
      track.scrollLeft += direction * 8;
      if (track.scrollLeft === before) { stop(); return; }
      animation = requestAnimationFrame(scrollFrame);
    };
    track.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'mouse' || reducedMotion()) return;
      const rect = track.getBoundingClientRect();
      const left = event.clientX - rect.left;
      const right = rect.right - event.clientX;
      const nextDirection = left <= 120 ? -1 : right <= 120 ? 1 : 0;
      if (!nextDirection && left > 140 && right > 140) { stop(); return; }
      if (nextDirection && nextDirection !== direction) {
        stop(); direction = nextDirection;
        animation = requestAnimationFrame(scrollFrame);
      }
    });
    track.addEventListener('pointerleave', stop);
    track.addEventListener('keydown', stop);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
    new ResizeObserver(sync).observe(track);
    sync();
  });

  const megaItems = Array.from(document.querySelectorAll('[data-mega-trigger]'));
  let megaCloseTimer = 0;
  let activeMegaItem = null;
  const setMegaState = (item, open) => {
    item.classList.toggle('is-mega-open', open);
    item.querySelector('.lev-nav-link')?.setAttribute('aria-expanded', String(open));
  };
  const closeMegaItems = (except) => {
    megaItems.forEach((item) => {
      if (item !== except) setMegaState(item, false);
    });
    if (!except) activeMegaItem = null;
  };
  const openMega = (item) => {
    window.clearTimeout(megaCloseTimer);
    activeMegaItem = item;
    item.classList.remove('is-menu-dismissed');
    closeMegaItems(item);
    setMegaState(item, true);
  };
  const scheduleMegaClose = (item) => {
    window.clearTimeout(megaCloseTimer);
    megaCloseTimer = window.setTimeout(() => {
      setMegaState(item, false);
      if (activeMegaItem === item) activeMegaItem = null;
      megaCloseTimer = 0;
    }, 300);
  };
  const pointerInsideActiveMega = (x, y) => {
    if (!activeMegaItem) return false;
    const link = activeMegaItem.querySelector('.lev-nav-link');
    const panel = activeMegaItem.querySelector('[data-mega-panel]');
    const rects = [link && link.getBoundingClientRect(), panel && panel.getBoundingClientRect()].filter(Boolean);
    if (!rects.length) return false;
    return rects.some((r) => x >= r.left - 24 && x <= r.right + 24 && y >= r.top - 24 && y <= r.bottom + 24);
  };
  megaItems.forEach((item, index) => {
    const launcher = item.querySelector('.lev-nav-link');
    const controlledPanel = item.querySelector('[data-mega-panel]');
    if (launcher && controlledPanel) {
      controlledPanel.id ||= `lev-desktop-submenu-${index}`;
      launcher.setAttribute('aria-controls', controlledPanel.id);
      launcher.setAttribute('aria-expanded', 'false');
      if (launcher.tagName === 'BUTTON') launcher.addEventListener('click', () => openMega(item));
    }
    item.addEventListener('pointerenter', () => openMega(item));
    item.addEventListener('mouseenter', () => openMega(item));
    item.addEventListener('focusin', () => openMega(item));
    item.addEventListener('focusout', () => scheduleMegaClose(item));
    const panel = item.querySelector('[data-mega-panel]');
    if (panel) {
      panel.addEventListener('pointerenter', () => openMega(item));
      panel.addEventListener('mouseenter', () => openMega(item));
      panel.addEventListener('pointerleave', (e) => {
        if (!pointerInsideActiveMega(e.clientX, e.clientY)) scheduleMegaClose(item);
      });
      panel.addEventListener('click', () => {
        window.clearTimeout(megaCloseTimer);
      });
    }
  });
  megaItems.forEach((item) => {
    item.addEventListener('mouseleave', () => scheduleMegaClose(item));
  });
  document.addEventListener('pointermove', (e) => {
    if (!activeMegaItem) return;
    if (pointerInsideActiveMega(e.clientX, e.clientY)) {
      window.clearTimeout(megaCloseTimer);
      megaCloseTimer = 0;
      return;
    }
    if (!megaCloseTimer) scheduleMegaClose(activeMegaItem);
  }, { passive: true });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const focusedItem = megaItems.find((item) => item.contains(document.activeElement));
      focusedItem?.querySelector('.lev-nav-link')?.focus();
      closeMegaItems();
      megaItems.forEach((item) => item.classList.add('is-menu-dismissed'));
    }
  });

  // Hover indicator — slides under hovered nav item (matches VTEX HoverIndicator)
  const levNav = document.querySelector('.lev-nav');
  const levIndicator = levNav && levNav.querySelector('.lev-hover-indicator');
  if (levNav && levIndicator) {
    const allNavItems = levNav.querySelectorAll('.lev-nav-item');
    allNavItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        levIndicator.style.left = item.offsetLeft + 'px';
        levIndicator.style.width = item.offsetWidth + 'px';
      });
    });
    levNav.addEventListener('mouseleave', () => {
      levIndicator.style.width = '0';
    });
  }

  document.querySelectorAll('[data-lazy-fade]').forEach((img) => {
    const markLoaded = () => img.classList.add('loaded');
    if (img.complete) markLoaded();
    else img.addEventListener('load', markLoaded, { once: true });
  });

  const responsiveImages = Array.from(document.querySelectorAll('[data-responsive-img]'));
  function swapResponsiveImages() {
    const isMobile = window.innerWidth <= 1040;
    responsiveImages.forEach((img) => {
      if (!img.dataset.desktopSrc) img.dataset.desktopSrc = img.currentSrc || img.src;
      const next = isMobile && img.dataset.mobileSrc ? img.dataset.mobileSrc : img.dataset.desktopSrc;
      if (img.src !== next) img.src = next;
    });
  }
  swapResponsiveImages();
  window.addEventListener('resize', swapResponsiveImages, { passive: true });

  document.addEventListener('click', function (e) {
    const targetLink = e.target.closest('[data-scroll-target]');
    if (targetLink) {
      const target = document.getElementById(targetLink.dataset.scrollTarget);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    const rowButton = e.target.closest('.lev-row-next,.lev-row-prev');
    if (rowButton) {
      const row = rowButton.closest('[data-scroll-row], .lev-store-cards, .lev-discover-row')
        || rowButton.parentElement.querySelector('[data-scroll-row], .lev-store-cards, .lev-discover-row');
      if (row) {
        if (typeof row._levStopHoverScroll === 'function') row._levStopHoverScroll();
        const dir = rowButton.classList.contains('lev-row-prev') ? -1 : 1;
        // LEV-104: com behavior 'smooth' o clique não navegava — o loop de
        // hover-scroll dispara scrollBy a cada frame e cancela a animação suave
        // do navegador. Com 'auto' o passo é aplicado direto e funciona sempre.
        row.scrollBy({ left: dir * 400, behavior: 'auto' });
      }
    }

    const storeCard = e.target.closest('[data-store-card]');
    if (storeCard) {
      const map = document.querySelector('[data-store-map]');
      if (map && storeCard.dataset.mapQuery) {
        map.src = `https://www.google.com/maps?q=${encodeURIComponent(storeCard.dataset.mapQuery)}&output=embed`;
        document.querySelectorAll('[data-store-card].is-active').forEach((card) => card.classList.remove('is-active'));
        storeCard.classList.add('is-active');
      }
    }

    const thumb = e.target.closest('[data-pdp-thumb]');
    if (thumb) {
      const wrap = thumb.closest('[data-product-gallery]');
      showProductImage(wrap, { src: thumb.dataset.full, alt: thumb.querySelector('img')?.alt });
    }

    if (e.target.matches('[data-qty-minus],[data-qty-plus]')) {
      const box = e.target.closest('[data-qty]');
      const q = box.querySelector('input');
      let v = parseInt(q.value || '1', 10);
      q.value = e.target.matches('[data-qty-minus]') ? Math.max(1, v - 1) : v + 1;
      const quantityForm = q.closest('form.lev-product-form');
      if (quantityForm) syncProductVariant(quantityForm);
      syncQtyMinus(box);
    }

    const filt = e.target.closest('[data-filter-toggle]');
    if (filt) {
      const panel = document.querySelector('[data-filter-panel]');
      if (panel) panel.classList.toggle('is-open');
      filt.classList.toggle('is-open');
    }

    const option = e.target.closest('.lev-selector-pill,.lev-color-dot,.lev-pill,.lev-swatch');
    if (option && option.parentElement) {
      option.parentElement.querySelectorAll('.is-selected').forEach((x) => x.classList.remove('is-selected'));
      option.classList.add('is-selected');
      const group = option.closest('.lev-selector-group');
      // LEV-105: o rótulo agora existe em toda opção ("Bateria: Chumbo"), não
      // só na cor — daí data-option-label no lugar de data-color-label.
      const label = group && group.querySelector('[data-option-label]');
      if (label && option.dataset.optionValue) label.textContent = option.dataset.optionValue;

      const form = option.closest('form.lev-product-form');
      if (form) {
        syncProductVariant(form);
      }
    }

  });

  // LEV-105: na referência o botão de menos fica apagado enquanto a quantidade
  // é 1, em vez de continuar clicável sem efeito.
  function syncQtyMinus(box) {
    const input = box.querySelector('input');
    const minus = box.querySelector('[data-qty-minus]');
    if (!input || !minus) return;
    minus.classList.toggle('is-disabled', parseInt(input.value || '1', 10) <= 1);
  }
  document.querySelectorAll('[data-qty]').forEach(syncQtyMinus);

  document.querySelectorAll('[data-mobile-snap]').forEach((row) => {
    const dotsRoot = row.closest('section') && row.closest('section').querySelector('[data-mobile-dots]');
    const cards = Array.from(row.querySelectorAll('.lev-discover-card'));
    if (!dotsRoot || !cards.length) return;
    dotsRoot.innerHTML = cards.map((_, i) => `<button type="button" aria-label="Ir para o card ${i + 1}"></button>`).join('');
    const dots = Array.from(dotsRoot.querySelectorAll('button'));
    const update = () => {
      const idx = clamp(Math.round(row.scrollLeft / Math.max(1, cards[0].offsetWidth + 16)), 0, cards.length - 1);
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
      cards.forEach((card, i) => card.classList.toggle('is-selected', i === idx));
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      row.scrollTo({ left: cards[i].offsetLeft - 32, behavior: 'smooth' });
    }));
    row.addEventListener('scroll', update, { passive: true });
    update();
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion) {
    const revealTargets = [
      '.lev-left-column',
      '.lev-tile',
      '.lev-discover-card',
      '.lev-testimonials h2',
      '.lev-t-card',
      '.lev-stores-head',
      '.lev-store-cards article',
      '.lev-blog-img',
      '.lev-blog-copy'
    ].join(',');

    const revealEls = Array.from(document.querySelectorAll(revealTargets));
    revealEls.forEach((el, index) => {
      el.classList.add('lev-reveal');
      el.style.setProperty('--lev-reveal-delay', `${Math.min(index % 6, 5) * 55}ms`);
    });

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    revealEls.forEach((el) => revealObserver.observe(el));
  }

  if (!reduceMotion) {
    document.querySelectorAll('.lev-discover-carousel,.lev-store-cards-wrap,[data-hover-scroll]').forEach((scope) => {
      const row = scope.matches('[data-scroll-row], .lev-store-cards, .lev-discover-row')
        ? scope
        : scope.querySelector('[data-scroll-row], .lev-store-cards, .lev-discover-row');
      if (!row) return;

      let raf = 0;
      let dir = 0;
      const startZone = 140;
      const stopZone = 168;
      const speed = row.classList.contains('lev-store-cards') ? 7 : 8;

      const stop = () => {
        if (raf) cancelAnimationFrame(raf);
        raf = 0;
        dir = 0;
      };

      row._levStopHoverScroll = stop;

      const frame = () => {
        if (!dir) return;
        const max = Math.max(0, row.scrollWidth - row.clientWidth);
        if (max <= 0) return stop();
        if (dir > 0 && row.scrollLeft >= max - 2) return stop();
        if (dir < 0 && row.scrollLeft <= 2) return stop();
        else row.scrollBy({ left: dir * speed, behavior: 'auto' });
        raf = requestAnimationFrame(frame);
      };

      row.addEventListener('pointermove', (e) => {
        if (window.innerWidth <= 570) return;
        if (e.target.closest('.lev-row-prev,.lev-row-next')) return stop();
        const box = row.getBoundingClientRect();
        const distLeft = e.clientX - box.left;
        const distRight = box.right - e.clientX;
        const nextDir = distLeft <= startZone ? -1 : distRight <= startZone ? 1 : 0;
        if (!nextDir && distLeft > stopZone && distRight > stopZone) return stop();
        if (nextDir && nextDir !== dir) {
          stop();
          dir = nextDir;
          raf = requestAnimationFrame(frame);
        }
      });
      row.addEventListener('pointerleave', stop);
      row.addEventListener('wheel', stop, { passive: true });
      row.addEventListener('touchstart', stop, { passive: true });
    });
  }

  document.querySelectorAll('.lev-discover-carousel,.lev-store-cards-wrap').forEach((scope) => {
    const row = scope.querySelector('[data-scroll-row], .lev-store-cards, .lev-discover-row');
    const prev = scope.querySelector('.lev-row-prev');
    const next = scope.querySelector('.lev-row-next');
    if (!row || !prev || !next) return;
    const updateButtons = () => {
      const max = Math.max(0, row.scrollWidth - row.clientWidth);
      prev.classList.toggle('is-disabled', row.scrollLeft <= 1);
      next.classList.toggle('is-disabled', row.scrollLeft >= max - 10);
    };
    row.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  const sequence = document.querySelector('[data-lev-seq]');
  if (sequence) {
    const imgs = Array.from(sequence.querySelectorAll('.seq-img'));
    const mode = sequence.dataset.seqMode || 'scroll_and_timer';
    let current = 0;
    const setSeq = (idx) => {
      current = clamp(idx, 0, imgs.length - 1);
      imgs.forEach((img, i) => img.classList.toggle('is-active', i === current));
    };
    const bikeEl = sequence.querySelector('.lev-bike-seq');
    const updateByScroll = () => {
      const r = sequence.getBoundingClientRect();
      const vh = window.innerHeight || 800;
      const p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      sequence.style.setProperty('--poss-text-y', `${window.innerWidth > 1200 ? window.pageYOffset * 0.22 : 0}px`);
      sequence.style.setProperty('--poss-bike-y', `${(p - 0.5) * -34}px`);
      sequence.style.setProperty('--poss-bg-x', `${(p - 0.5) * -54}px`);
      sequence.style.setProperty('--poss-bg-y', `${(p - 0.5) * 28}px`);
      if (bikeEl) {
        const br = bikeEl.getBoundingClientRect();
        const reveal = clamp((vh - br.top) / (br.height * 0.55), 0, 1);
        sequence.style.setProperty('--poss-bike-reveal', reveal.toFixed(3));
        sequence.style.setProperty('--poss-bike-scale', (0.94 + reveal * 0.06).toFixed(3));
      }
      if (mode !== 'timer') setSeq(Math.round(p * (imgs.length - 1)));
    };
    let seqRaf = false;
    const onSeqScroll = () => {
      if (seqRaf) return;
      seqRaf = true;
      requestAnimationFrame(() => {
        updateByScroll();
        seqRaf = false;
      });
    };
    window.addEventListener('scroll', onSeqScroll, { passive: true });
    window.addEventListener('resize', onSeqScroll);
    updateByScroll();
    if (mode !== 'scroll') {
      setInterval(() => {
        const r = sequence.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        setSeq((current + 1) % imgs.length);
      }, 900);
    }
  }

  const cruiser = document.querySelector('.lev-cruiser-banner');
  if (cruiser) {
    cruiser.style.setProperty('--cruiser-bg-y', '0px');
    cruiser.style.setProperty('--cruiser-bg-scale', '1.02');
    cruiser.style.setProperty('--cruiser-card-y', '0px');
  }

  /* LEV-104: o box "Chegou a nova" ficava estático — a regra CSS já lia
     --cruiser-card-y, mas nada atualizava a variável no scroll. Mesmo cálculo
     do updateFarmCard e de 00HomeBanner02.tsx (range de 30vh). */
  const cruiserCard = document.querySelector('.lev-cruiser-content');
  if (cruiserCard && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const cruiserMobile = window.matchMedia('(max-width: 700px)');
    let cruiserRaf = 0;
    const updateCruiserCard = () => {
      cruiserRaf = 0;
      if (cruiserMobile.matches) {
        cruiserCard.style.setProperty('--cruiser-card-y', '0px');
        return;
      }
      const rect = cruiserCard.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight || 800;
      const cardCenter = rect.top + rect.height / 2;
      const offset = clamp((cardCenter - vh / 2) / vh, -1, 1) * (0.3 * vh);
      cruiserCard.style.setProperty('--cruiser-card-y', `${Math.abs(offset) < 1 ? 0 : offset}px`);
    };
    const onCruiserScroll = () => {
      if (!cruiserRaf) cruiserRaf = requestAnimationFrame(updateCruiserCard);
    };
    updateCruiserCard();
    window.addEventListener('scroll', onCruiserScroll, { passive: true });
    window.addEventListener('resize', onCruiserScroll);
  }

  const farmCard = document.querySelector('.lev-farm-banner-card');
  if (farmCard && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const mobileQuery = window.matchMedia('(max-width: 700px)');
    let farmRaf = 0;
    const updateFarmCard = () => {
      farmRaf = 0;
      if (mobileQuery.matches) {
        farmCard.style.setProperty('--farm-card-y', '0px');
        return;
      }
      const rect = farmCard.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight || 800;
      const cardCenter = rect.top + rect.height / 2;
      const offset = clamp((cardCenter - vh / 2) / vh, -1, 1) * (0.3 * vh);
      farmCard.style.setProperty('--farm-card-y', `${Math.abs(offset) < 1 ? 0 : offset}px`);
    };
    const onFarmScroll = () => {
      if (!farmRaf) farmRaf = requestAnimationFrame(updateFarmCard);
    };
    updateFarmCard();
    window.addEventListener('scroll', onFarmScroll, { passive: true });
    window.addEventListener('resize', onFarmScroll);
  }

	document.querySelectorAll('[data-lev-testimonials]').forEach((root) => {
	  const script = root.querySelector('[data-testimonials-json]');
    let data = [];
    try {
      data = JSON.parse(script ? script.textContent : '[]');
    } catch (e) {
      data = [];
    }
    if (!data.length) {
      data = [
        { name: 'Ana', image: 'home07-01ana.webp', text: 'Essa Bike é um investimento, ela mudou meus hábitos... sou muito mais feliz com meu novo estilo de vida que só a Lev pôde me proporcionar.', date: '05/07/25' },
        { name: 'Thiago', image: 'home07-02thiago.webp', text: 'Mesmo com previsão de chuva a vontade de ir de Lev é gigante', date: '15/07/25' }
      ];
    }
	  let i = Math.min(1, data.length - 1);
	  let direction = 'right';
	  let firstRender = true;
	  const fillCard = (card, item) => {
	    const img = card.querySelector('img');
	    if (img) {
	      img.src = assetUrl(item.image);
	      img.alt = item.name;
	    }
	    const name = card.querySelector('strong');
	    const date = card.querySelector('span');
	    const text = card.querySelector('p');
	    if (name) name.textContent = item.name;
	    if (date) date.textContent = item.date;
	    if (text) text.textContent = item.text;
	  };
	  const removePassClasses = (card) => {
	    const avatar = card.querySelector(':scope > div');
	    const text = card.querySelector('p');
	    card.classList.remove('lev-t-card-pass', 'from-left', 'from-right');
	    avatar?.classList.remove('lev-t-avatar-pass', 'from-left', 'from-right');
	    text?.classList.remove('lev-t-text-pass');
	  };
	  const animateProdPass = (card) => {
	    if (window.innerWidth < 901) return;
	    const avatar = card.querySelector(':scope > div');
	    const text = card.querySelector('p');
	    removePassClasses(card);
	    void card.offsetWidth;
	    card.classList.add('lev-t-card-pass');
	    avatar?.classList.add('lev-t-avatar-pass', direction === 'left' ? 'from-left' : 'from-right');
	    text?.classList.add('lev-t-text-pass');
	    window.setTimeout(() => removePassClasses(card), 540);
	  };
	  const render = () => {
	    const left = (i - 1 + data.length) % data.length;
	    const right = (i + 1) % data.length;
	    const cur = data[i];
	    const prevImg = root.querySelector('[data-dir="prev"] img');
	    const nextImg = root.querySelector('[data-dir="next"] img');
	    const card = root.querySelector('.lev-t-card');
	    if (!card || !prevImg || !nextImg) return;
	    prevImg.src = assetUrl(data[left].image);
	    prevImg.alt = data[left].name;
	    nextImg.src = assetUrl(data[right].image);
	    nextImg.alt = data[right].name;
	    fillCard(card, cur);
	    if (!firstRender) animateProdPass(card);
	    firstRender = false;
	  };
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-dir]');
      if (!btn) return;
      direction = btn.dataset.dir === 'prev' ? 'left' : 'right';
      i = btn.dataset.dir === 'prev' ? (i - 1 + data.length) % data.length : (i + 1) % data.length;
      render();
    });
    setInterval(() => {
      const r = root.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      direction = 'right';
      i = (i + 1) % data.length;
      render();
    }, 4000);
    render();
  });

  document.querySelector('[data-store-card]')?.classList.add('is-active');

  document.querySelectorAll('[data-photo-wall]').forEach((wall) => {
    const grid = wall.querySelector('.lev-wall-grid');
    if (!grid) return;
    const gap = 15;
    const maxImgs = parseInt(wall.dataset.photoCount || '60', 10);

    const compute = () => {
      const width = wall.clientWidth;
      const isNarrow = width <= 576;
      const colMin = isNarrow ? 50 : 80;
      const rowH = isNarrow ? 50 : 91;
      const rowCount = isNarrow ? 8 : 3;
      const cols = Math.max(1, Math.floor((width + gap) / (colMin + gap)));

      grid.style.gridTemplateColumns = `repeat(${cols}, minmax(${colMin}px, 1fr))`;
      grid.style.gridAutoRows = `${rowH}px`;
      grid.style.height = `${rowCount * rowH + (rowCount - 1) * gap}px`;
      grid.style.overflow = 'hidden';

      const occ = Array.from({ length: rowCount }, () => Array(cols).fill(false));
      const positions = [];

      for (let r = 0; r < Math.min(2, rowCount - 1); r++) {
        for (let c = 0; c < cols - 1; c++) {
          if (positions.length >= cols * rowCount) break;
          const r1 = occ[r + 1];
          if (!occ[r][c] && !occ[r][c + 1] && r1 && !r1[c] && !r1[c + 1] && Math.random() < 0.22) {
            positions.push({ r, c, size: 2 });
            occ[r][c] = occ[r][c + 1] = r1[c] = r1[c + 1] = true;
          }
        }
      }
      for (let r = 0; r < rowCount; r++) {
        for (let c = 0; c < cols; c++) {
          if (!occ[r][c]) { positions.push({ r, c, size: 1 }); occ[r][c] = true; }
        }
      }

      const imgs = Array.from(grid.querySelectorAll('img'));
      imgs.forEach((img, i) => {
        const pos = positions[i];
        if (pos) {
          img.style.gridRow = `${pos.r + 1} / span ${pos.size}`;
          img.style.gridColumn = `${pos.c + 1} / span ${pos.size}`;
          img.style.display = '';
        } else {
          img.style.display = 'none';
        }
      });
    };

    compute();
    let resizeT;
    window.addEventListener('resize', () => { clearTimeout(resizeT); resizeT = setTimeout(compute, 120); });

    const imgs = Array.from(grid.querySelectorAll('img'));
    let next = 0;
    setInterval(() => {
      const r = wall.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      const visible = imgs.filter(i => i.style.display !== 'none');
      if (!visible.length) return;
      const target = visible[Math.floor(Math.random() * visible.length)];
      next = (next % maxImgs) + 1;
      const n = String(next).padStart(5, '0');
      const src = assetUrl(`pw-${n}.webp`);
      const pre = new Image();
      pre.onload = () => {
        target.classList.add('is-swapping');
        setTimeout(() => {
          target.src = src;
          target.alt = `Lev lifestyle ${next}`;
          target.classList.remove('is-swapping');
        }, 120);
      };
      pre.src = src;
    }, 500);
  });

  const sidecart = document.querySelector('[data-sidecart]');
  const sidecartBody = document.querySelector('[data-sidecart-body]');
  const sidecartFooter = document.querySelector('[data-sidecart-footer]');
  const sidecartTotal = document.querySelector('[data-sidecart-total]');
  const sidecartPanel = sidecart?.querySelector('.lev-sidecart__panel');
  const inertBackground = new Map();
  let sidecartOpener = null;
  if (sidecart) sidecart.inert = true;
  const focusSidecart = () => sidecartPanel?.querySelector('[data-sidecart-close]')?.focus({ preventScroll: true });
  const setCartBackgroundInert = () => {
    for (let branch = sidecart; branch?.parentElement && branch !== document.body; branch = branch.parentElement) {
      for (const sibling of branch.parentElement.children) {
        if (sibling === branch || !(sibling instanceof HTMLElement) || inertBackground.has(sibling)) continue;
        inertBackground.set(sibling, sibling.inert);
        sibling.inert = true;
      }
    }
  };
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((cents || 0) / 100);
    } catch (e) {
      return `R$ ${((cents || 0) / 100).toFixed(2).replace('.', ',')}`;
    }
  };
  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count], .lev-cart-count').forEach((el) => {
      el.textContent = String(count || 0);
      el.classList.toggle('is-empty', !count);
    });
  };
  const escapeCartText = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  const renderSidecart = (cart) => {
    if (!cartSession.isCart(cart)) throw new Error('Invalid cart response');
    if (!sidecartBody) return;
    sidecart.dataset.cartReadState = 'ready';
    updateCartCount(cart.item_count);
    if (sidecartFooter) sidecartFooter.hidden = cart.item_count === 0;
    if (sidecartTotal) sidecartTotal.textContent = money(cart.total_price);
    const offer = window.LevPaymentOffer;
    if (offer && Number.isFinite(cart.total_price)) {
      const offerPrices = offer.cartPrices(Number.isFinite(cart.original_total_price) ? cart.original_total_price : cart.total_price, cart.total_price);
      document.querySelectorAll('[data-sidecart-offer-pix]').forEach(element => { element.textContent = money(offerPrices.pix); });
      document.querySelectorAll('[data-sidecart-offer-card]').forEach(element => { element.textContent = money(offerPrices.card); });
      document.querySelectorAll('[data-sidecart-offer-card-label]').forEach(element => { element.textContent = offer.text('cart_card', offerPrices); });
    }

    if (!cart.items.length) {
      sidecartBody.innerHTML = '<p class="lev-sidecart__empty">Seu carrinho está vazio.</p>';
      cartSession.refresh();
      return;
    }

    sidecartBody.innerHTML = cart.items.map((item) => `
      <article class="lev-sidecart__item" data-cart-key="${escapeCartText(item.key)}">
        ${item.image ? `<img src="${escapeCartText(item.image)}" width="86" height="86" loading="lazy" alt="${escapeCartText(item.product_title)}">` : ''}
        <div>
          <h3>${escapeCartText(item.product_title)}</h3>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeCartText(item.variant_title)}</p>` : ''}
          <div class="lev-sidecart__qty">
            <button type="button" data-sidecart-qty="-1" aria-label="Diminuir">-</button>
            <span>${item.quantity}</span>
            <button type="button" data-sidecart-qty="1" aria-label="Aumentar">+</button>
          </div>
        </div>
        <strong>${money(item.final_line_price)}</strong>
      </article>
    `).join('');
    cartSession.refresh();
  };
  const fetchCart = async () => {
    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(20000) });
    if (!res.ok) throw new Error('cart fetch failed');
    const cart = await res.json();
    if (!cartSession.isCart(cart)) throw new Error('Invalid cart response');
    return cart;
  };
  let readRevision = 0;
  const sidecartStatus = (message, review = false) => {
    const panel = sidecart.querySelector('.lev-sidecart__panel') || sidecart;
    showCartStatus(panel, message, review);
    const status = panel.querySelector('[data-cart-status]');
    if (sidecartBody && status) sidecartBody.before(status);
  };
  const openSidecart = async (refresh = true, opener = document.activeElement) => {
    if (!sidecart) return;
    const wasOpen = sidecart.classList.contains('is-open');
    if (!wasOpen) sidecartOpener = opener;
    sidecart.inert = false;
    sidecart.classList.add('is-open');
    sidecart.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lev-sidecart-open');
    if (!wasOpen) { focusSidecart(); setCartBackgroundInert(); }
    if (cartSession.blocked()) sidecartStatus(cartSession.snapshot().uncertain ? messages.cartUncertain : messages.cartUpdating, cartSession.snapshot().uncertain);
    if (refresh && !cartSession.blocked()) {
      const requestId = ++readRevision;
      const version = cartSession.snapshot().revision;
      sidecart.setAttribute('aria-busy', 'true');
      sidecart.dataset.cartReadState = 'loading';
      cartSession.refresh();
      sidecartStatus(messages.cartLoading);
      try {
        const cart = await fetchCart();
        if (requestId !== readRevision || version !== cartSession.snapshot().revision) return;
        renderSidecart(cart);
        sidecartStatus('');
      } catch (error) {
        if (requestId === readRevision && version === cartSession.snapshot().revision) {
          sidecart.dataset.cartReadState = 'failed';
          cartSession.refresh();
          sidecartStatus(messages.cartReadError, true);
        }
      } finally {
        if (requestId === readRevision) sidecart.setAttribute('aria-busy', 'false');
      }
    }
  };
  document.addEventListener('lev:cart-state', event => {
    if (sidecart?.classList.contains('is-open') && event.detail.uncertain) sidecartStatus(messages.cartUncertain, true);
  });
  const closeSidecart = () => {
    if (!sidecart) return;
    sidecart.classList.remove('is-open');
    sidecart.setAttribute('aria-hidden', 'true');
    sidecart.inert = true;
    document.body.classList.remove('lev-sidecart-open');
    inertBackground.forEach((wasInert, element) => { element.inert = wasInert; });
    inertBackground.clear();
    const opener = sidecartOpener?.isConnected && !sidecartOpener.closest('[inert]') && !sidecartOpener.disabled ? sidecartOpener : document.querySelector('[data-sidecart-open]');
    opener?.focus({ preventScroll: true });
  };
  document.addEventListener('keydown', event => {
    if (!sidecart?.classList.contains('is-open')) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); closeSidecart(); return; }
    if (event.key !== 'Tab' || !sidecartPanel) return;
    const controls = [...sidecartPanel.querySelectorAll('button, a[href], input, select, textarea, [tabindex]')].filter(element => element.tabIndex >= 0 && !element.disabled && element.getAttribute('aria-disabled') !== 'true' && !element.closest('[hidden], [inert]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const first = controls[0], last = controls.at(-1), current = document.activeElement;
    if (!controls.includes(current) || (event.shiftKey && current === first) || (!event.shiftKey && current === last)) {
      event.preventDefault();
      (event.shiftKey ? last : first)?.focus({ preventScroll: true });
    }
  }, true);

  document.addEventListener('click', async (e) => {
    const cartTrigger = e.target.closest('[data-sidecart-open]');
    if (cartTrigger) {
      // LEV-22: sem painel no DOM, o preventDefault deixava o clique sem efeito
      // nenhum — nem gaveta, nem /cart. Se a gaveta não existe nesta rota, o
      // link segue o href normalmente.
      if (!sidecart) return;
      e.preventDefault();
      openSidecart(true, cartTrigger);
      return;
    }

    if (e.target.closest('[data-sidecart-close]')) {
      e.preventDefault();
      closeSidecart();
      return;
    }

    const qtyButton = e.target.closest('[data-sidecart-qty]');
    if (qtyButton) {
      if (sidecart.dataset.cartReadState && sidecart.dataset.cartReadState !== 'ready') return;
      const item = qtyButton.closest('[data-cart-key]');
      const quantity = Number(item?.querySelector('.lev-sidecart__qty span')?.textContent);
      const nextQuantity = quantity + Number(qtyButton.dataset.sidecartQty);
      if (!item || !Number.isSafeInteger(nextQuantity) || nextQuantity < 0) return;
      const token = cartSession.begin();
      if (!token) return;
      sidecart.setAttribute('aria-busy', 'true');
      sidecartStatus(messages.cartUpdating);
      let confirmed = false;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.dataset.cartKey, quantity: nextQuantity }),
          signal: AbortSignal.timeout(20000),
        });
        if (!response.ok) throw new Error('Cart change requires review');
        renderSidecart(await response.json());
        confirmed = true;
        sidecartStatus(messages.cartUpdated);
        document.dispatchEvent(new CustomEvent('lev:cart-updated'));
      } catch (error) {
        sidecartStatus(messages.cartUncertain, true);
      } finally {
        cartSession.finish(token, confirmed);
        sidecart.setAttribute('aria-busy', 'false');
      }
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    if (pendingAdds.has(form) || form.dataset.cartUncertain === 'true' || !syncProductVariant(form)) return;
    const token = cartSession.begin();
    if (!token) return;
    pendingAdds.add(form);
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    let accepted = false;
    let confirmed = false;
    try {
      const res = await fetch(form.action, {
        method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(20000),
      });
      // Cart API errors (including 422) may accompany partial additions.
      if (!res.ok) throw new Error('Cart addition requires review');
      accepted = true;
      renderSidecart(await fetchCart());
      openSidecart(false, button);
      showCartStatus(form, messages.cartAdded, true);
      confirmed = true;
      document.dispatchEvent(new CustomEvent('lev:cart-updated'));
    } catch (error) {
      form.dataset.cartUncertain = 'true';
      showCartStatus(form, accepted ? messages.cartAddedReview : messages.cartUncertain, true);
    } finally {
      cartSession.finish(token, confirmed);
      pendingAdds.delete(form);
      form.removeAttribute('aria-busy');
      if (button) button.disabled = form.dataset.cartUncertain === 'true';
      if (form.matches('.lev-product-form')) syncProductVariant(form);
    }
  });

  // Footer accordion (mobile only) — produção colapsa cada coluna do rodapé
  // no mobile e mantém tudo aberto no desktop. O CSS cuida do max-height; aqui
  // só alternamos a classe, e no desktop os cliques são ignorados.
  const footerAccordion = window.matchMedia('(max-width: 576px)');
  document.querySelectorAll('.lev-footer-links > div, .lev-footer .lev-help').forEach((col) => {
    const head = col.querySelector('h4');
    if (!head || !col.querySelector('ul')) return;
    // Sem `role="button"`: na produção o h4 do rodapé é só um heading com
    // `aria-expanded` e `cursor: pointer` (MobFooter__CategoryHeader). O role
    // aqui não era inócuo — em alto contraste a folha da produção pinta todo
    // `[role="button"]` de amarelo sólido, e as cinco colunas do rodapé viravam
    // cinco tarjas amarelas que não existem em www.golev.com.br. O tabindex
    // fica, para o teclado continuar alcançando o acordeão no mobile.
    head.setAttribute('tabindex', '0');
    head.setAttribute('aria-expanded', 'false');
    const list = col.querySelector('ul');
    // O max-height colapsado vem de uma regra !important no CSS mobile, então
    // abrir só com classe não vence a cascata — o valor aberto é aplicado
    // inline, também como important.
    const toggle = () => {
      if (!footerAccordion.matches) return;
      const open = col.classList.toggle('is-acc-open');
      if (open) {
        list.style.setProperty('max-height', `${list.scrollHeight}px`, 'important');
      } else {
        list.style.removeProperty('max-height');
      }
      head.setAttribute('aria-expanded', String(open));
    };
    footerAccordion.addEventListener('change', (e) => {
      if (e.matches) return;
      col.classList.remove('is-acc-open');
      list.style.removeProperty('max-height');
    });
    head.addEventListener('click', toggle);
    head.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });

  // Manuais search filter
  const manualSearch = document.getElementById('lev-manual-search');
  if (manualSearch) {
    const rows = document.querySelectorAll('[data-model]');
    manualSearch.addEventListener('input', () => {
      const q = manualSearch.value.trim().toLowerCase();
      rows.forEach((row) => {
        row.hidden = q && !row.dataset.model.includes(q);
      });
    });
  }
});
